module.exports = __webpack_public_path__ + "static/img/0401_05.10ea616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0401_05.png
// module id = Hw49
// module chunks = 1